import React from "react"
import { Button, Currencies, SFXS } from "@orbital/games-frontend-library"
import { Wrapper } from "../../styled"

export default function CancelFooter({
  footerState,
  cancelBet,
  disable,
  stake,
  currency,
}: any) {
  return (
    <Wrapper footerState={footerState === "cancelBet"} height="95px">
      <Button
        width="100%"
        background="tranparent"
        textColor="FFB000"
        func={(b: boolean) => b && cancelBet()}
        SFX={SFXS.goBackSFX}
        customClass={disable && "disable"}
      >
        <span>
          CANCEL {Currencies[currency]}
          {stake}
        </span>
      </Button>
      <p>WAITING FOR NEXT LAUNCH</p>
    </Wrapper>
  )
}
